$(document).ready(function () {
    const dogBreeds=[{breed:"Affenpinscher",weight:25},{breed:"Afghan Hound",weight:25},{breed:"Airedale Terrier",weight:25},{breed:"Akita",weight:25},{breed:"Alaskan Malamute",weight:25},{breed:"American Hairless Terrier",weight:25},{breed:"American Staffordshire Terrier",weight:25},{breed:"Anatolian Shepherd Dog",weight:25},{breed:"Australian Cattle Dog",weight:25},{breed:"Australian Kelpie",weight:25},{breed:"Australian Silky Terrier",weight:25},{breed:"Australian Stumpy Tail Cattle Dog",weight:25},{breed:"Australian Terrier",weight:25},{breed:"Azawakh",weight:25},{breed:"Basenji",weight:25},{breed:"Basset Fauve de Bretagne",weight:25},{breed:"Basset Hound",weight:25},{breed:"Beagle	Bearded Collie",weight:25},{breed:"Bedlington Terrier",weight:25},{breed:"Belgian Shepherd Dog Groenendael",weight:25},{breed:"Belgian Shepherd Dog Laekenois",weight:25},{breed:"Belgian Shepherd Dog Malinois",weight:25},{breed:"Belgian Shepherd Dog Tervuren",weight:25},{breed:"Bergamasco Shepherd Dog",weight:25},{breed:"Bernese Mountain Dog",weight:25},{breed:"Bichon Frise",weight:25},{breed:"Black and Tan Coonhound",weight:25},{breed:"Bloodhound",weight:25},{breed:"Bluetick Coonhound",weight:25},{breed:"Border Collie",weight:25},{breed:"Border Terrier",weight:25},{breed:"Borzoi	Boston Terrier",weight:25},{breed:"Bouvier des Flandres",weight:25},{breed:"Boxer",weight:25},{breed:"Bracco Italiano",weight:25},{breed:"Briard",weight:25},{breed:"British Bulldog",weight:25},{breed:"Brittany",weight:25},{breed:"Bull Terrier",weight:25},{breed:"Bullmastiff",weight:25},{breed:"Cairn Terrier",weight:25},{breed:"Canaan Dog",weight:25},{breed:"Canadian Eskimo Dog",weight:25},{breed:"Cane Corso",weight:25},{breed:"Caucasian Shepherd Dog",weight:25},{breed:"Cavalier King Charles Spaniel",weight:25},{breed:"Cavoodle",weight:25},{breed:"Central Asian Shepherd Dog",weight:25},{breed:"Cesky	Chesapeake Bay Retriever",weight:25},{breed:"Chihuahua",weight:25},{breed:"Chinese Crested Dog",weight:25},{breed:"Chow Chow",weight:25},{breed:"Clumber Spaniel",weight:25},{breed:"Cockapoo",weight:25},{breed:"Cocker Spaniel",weight:25},{breed:"Collie",weight:25},{breed:"Coton De Tulear",weight:25},{breed:"Curly Coated Retriever",weight:25},{breed:"Dachschund",weight:25},{breed:"Dalmatian",weight:25},{breed:"Dandie Dinmont Terrier",weight:25},{breed:"Deerhound",weight:25},{breed:"Doberman",weight:25},{breed:"Dogue de Bordeaux",weight:25},{breed:"Dutch Shepherd Dog",weight:25},{breed:"English Setter",weight:25},{breed:"English Springer Spaniel",weight:25},{breed:"English Toy Terrier",weight:25},{breed:"Estrela Mountain Dog",weight:25},{breed:"Eurasier",weight:25},{breed:"Field Spaniel",weight:25},{breed:"Finnish Lapphund",weight:25},{breed:"Finnish Spitz",weight:25},{breed:"Flat Coated Retriever",weight:25},{breed:"Fox Terrier",weight:25},{breed:"Foxhound",weight:25},{breed:"French Bulldog",weight:25},{breed:"German Hunting Terrier",weight:25},{breed:"German Pinscher",weight:25},{breed:"German Shepherd",weight:25},{breed:"German Shorthaired Pointer",weight:25},{breed:"German Spitz",weight:25},{breed:"German Wirehaired Pointer",weight:25},{breed:"Giant Schnauzer",weight:25},{breed:"Glen of Imaal Terrier",weight:25},{breed:"Golden Retriever",weight:25},{breed:"Gordon Setter",weight:25},{breed:"Grand Basset Griffon Vendeen",weight:25},{breed:"Great Dane",weight:25},{breed:"Greyhound",weight:25},{breed:"Griffon Bruxellois",weight:25},{breed:"Groodle",weight:25},{breed:"Hamilton Hound",weight:25},{breed:"Harrier",weight:25},{breed:"Havanese",weight:25},{breed:"Hungarian Vizsla",weight:25},{breed:"Hungarian Wirehaired Vizsla",weight:25},{breed:"Ibizan Hound",weight:25},{breed:"Icelandic Sheepdog",weight:25},{breed:"Irish Red and White Setter",weight:25},{breed:"Irish Setter",weight:25},{breed:"Irish Terrier",weight:25},{breed:"Irish Water Spaniel",weight:25},{breed:"Irish Wolfhound",weight:25},{breed:"Italian Greyhound",weight:25},{breed:"Italian Spinone",weight:25},{breed:"Jack Russell Terrier",weight:25},{breed:"Japanese Chin",weight:25},{breed:"Japanese Spitz",weight:25},{breed:"Kangal Shepherd Dog",weight:25},{breed:"Keeshond",weight:25},{breed:"Kerry Blue Terrier",weight:25},{breed:"King Charles Spaniel",weight:25},{breed:"Komondor",weight:25},{breed:"Kuvasz	Labradoodle",weight:25},{breed:"Labrador Retriever",weight:25},{breed:"Lagotto Romagnolo",weight:25},{breed:"Lakeland Terrier",weight:25},{breed:"Landseer",weight:25},{breed:"Large Munsterlander",weight:25},{breed:"Leonberger",weight:25},{breed:"Lhasa Apso",weight:25},{breed:"Lowchen",weight:25},{breed:"Maltese",weight:25},{breed:"Maltipoo",weight:25},{breed:"Manchester Terrier",weight:25},{breed:"Maremma Sheepdog",weight:25},{breed:"Mastiff",weight:25},{breed:"Miniature Bull Terrier",weight:25},{breed:"Miniature Pinscher",weight:25},{breed:"Miniature Poodle",weight:25},{breed:"Miniature Schnauzer",weight:25},{breed:"Neapolitan Mastiff",weight:25},{breed:"Newfoundland",weight:25},{breed:"Norfolk Terrier",weight:25},{breed:"Norwegian Buhund",weight:25},{breed:"Norwegian Elkhound",weight:25},{breed:"Norwich Terrier",weight:25},{breed:"Nova Scotia Duck Tolling Retriever",weight:25},{breed:"Old English Sheepdog",weight:25},{breed:"Otterhound",weight:25},{breed:"Papillon",weight:25},{breed:"Parson Russell Terrier",weight:25},{breed:"Pekingese",weight:25},{breed:"Peruvian Hairless Dog",weight:25},{breed:"Petit Basset Griffon Vendeen",weight:25},{breed:"Pharaoh Hound",weight:25},{breed:"Pointer",weight:25},{breed:"Polish Lowland Sheepdog",weight:25},{breed:"Pomeranian",weight:25},{breed:"Portuguese Podengo",weight:25},{breed:"Portuguese Water Dog",weight:25},{breed:"Pug",weight:25},{breed:"Puli",weight:25},{breed:"Pumi",weight:25},{breed:"Pyrenean Mastiff",weight:25},{breed:"Pyrenean Mountain Dog",weight:25},{breed:"Rhodesian Ridgeback",weight:25},{breed:"Rottweiler",weight:25},{breed:"Russian Black Terrier",weight:25},{breed:"Russian Toy",weight:25},{breed:"Saint Bernard",weight:25},{breed:"Saluki",weight:25},{breed:"Samoyed",weight:25},{breed:"Schipperke",weight:25},{breed:"Schnoodle",weight:25},{breed:"Scottish Terrier",weight:25},{breed:"Sealyham Terrier",weight:25},{breed:"Shar Pei",weight:25},{breed:"Shetland Sheepdog",weight:25},{breed:"Shiba Inu",weight:25},{breed:"Shih-Poo",weight:25},{breed:"Shih Tzu",weight:25},{breed:"Siberian Husky",weight:25},{breed:"Skye Terrier",weight:25},{breed:"Sloughi",weight:25},{breed:"Soft Coated Wheaten Terrier",weight:25},{breed:"Spanish Mastiff",weight:25},{breed:"Spanish Water Dog",weight:25},{breed:"Spoodle",weight:25},{breed:"Staffordshire Bull Terrier",weight:25},{breed:"Standard Poodle",weight:25},{breed:"Standard Schnauzer",weight:25},{breed:"Sussex Spaniel",weight:25},{breed:"Swedish Lapphund",weight:25},{breed:"Swedish Vallhund",weight:25},{breed:"Tatra Shepherd Dog",weight:25},{breed:"Tenterfield Terrier",weight:25},{breed:"Tibetan Mastiff",weight:25},{breed:"Tibetan Spaniel",weight:25},{breed:"Tibetan Terrier",weight:25},{breed:"Toy Poodle",weight:25},{breed:"Weimaraner",weight:25},{breed:"Welsh Corgi Cardigan",weight:25},{breed:"Welsh Corgi Pembroke",weight:25},{breed:"Welsh Springer Spaniel",weight:25},{breed:"Welsh Terrier",weight:25},{breed:"West Highland White Terrier",weight:25},{breed:"Whippet",weight:25},{breed:"White Swiss Shepherd Dog",weight:25},{breed:"Wirehaired Slovakian Pointer",weight:25},{breed:"Xoloitzcuintli",weight:25},{breed:"Yorkshire Terrier",weight:25},{breed:"Other",weight:25}];

    const $breedSelect = $('#DogBreed');
    const $weightSlider = $('#DogWeight');
    const $weightInput = $('#DogKg');
    const $activityLevel = $('#ActivityLevel');
    const $calculateButton = $('#calculate-subscription');
    const $resultsContainer = $('#calc-results');

    // Populate the dropdown with dog breeds
    $.each(dogBreeds, function (index, dog) {
        $breedSelect.append(
            $('<option>')
                .val(dog.breed)
                .text(dog.breed)
                .data('weight', dog.weight) // Store average weight as data attribute
        );
    });

    // Update the weight range when a breed is selected
    /*$breedSelect.on('change', function () {
        const $selectedOption = $(this).find('option:selected');
        const averageWeight = $selectedOption.data('weight');

        if (averageWeight) {
            $weightInput.val(averageWeight).trigger('change');
        } else {
            $weightInput.val('').trigger('change');
        }
    });*/

    // Set dog weight label

    $weightInput.val($weightSlider.val());

    $weightSlider.on('change', function () {
        $weightInput.val($(this).val());
    });
    $weightInput.on('change', function () {
        $weightSlider.val($(this).val());
    });

    // Generate subscription recommendation on button click
    $calculateButton.on('click', function (e) {
        e.preventDefault();

        const dogName = $('#DogName').val();
        const breed = $breedSelect.val();
        const weight = $weightInput.val();
        const activity = $activityLevel.val();

        if (!dogName || !breed || !weight || !activity) {
            alert('Please fill out all fields before calculating the subscription.');
            return;
        }

        // Calculate subscription frequency based on weight and activity level
        let days = calculateDays(weight, activity);

        // Generate the subscription menu
        const subscriptionHTML = `
            <div class="subscription-suggestion">
                <p>Based on your answers about <strong>${dogName}</strong>, we suggest:</p>
                <p>1 Box of Fetched Every</p>
                <div class="subscription-frequency">
                    <span class="frequency-days">${days} Days</span>
                </div>
                <p class="sub-heading">Or would you prefer to <span style="text-decoration: underline">choose your own subscription length?</span></p>
                <p><input type="number" name="Frequency" class="sub-days camo-input" value="${days}" min="7" max="365"> <span>
                    Days
                </span></p>
                <button class="pink-button paw-button-blue">Subscribe Now</button>
            </div>
        `;

        // Insert the generated HTML into the results container
        $resultsContainer.html(subscriptionHTML);
        $('html').animate({
            scrollTop: $resultsContainer.offset().top
        }, 800)
    });

    $(document).on('click', '.subscribe-now', function () {
        const sku = 'FETCHED-BOX'; // The SKU of your product
        const days = $('.sub-days').val(); // Get the custom days input value

        $.ajax({
            url: '/subscription/addSubscriptionToCart', // URL defined in your route
            method: 'POST',
            dataType: 'json',
            data: {
                sku: sku,
                days: days
            },
            success: function (response) {
                const result = JSON.parse(response);
                if (result.success) {
                    alert('Product added to cart successfully!');
                    // Optionally, update the cart UI here
                } else {
                    alert(result.message || 'An error occurred.');
                }
            },
            error: function (xhr) {
                console.error(xhr);
                alert('Failed to add product to cart: ' + xhr.responseText);
            }
        });
    });

    function calculateDays(weight, activity) {
        let calculations = {
            "1-7": "lazy:90_typical:90_active:90",
            "8-10": "lazy:46_typical:46_active:30",
            "11-15": "lazy:30_typical:30_active:23",
            "16-20": "lazy:30_typical:30_active:23",
            "21-25": "lazy:23_typical:23_active:23",
            "26-30": "lazy:23_typical:23_active:18",
            "31-40": "lazy:18_typical:15_active:15",
            "41-46": "lazy:15_typical:15_active:13",
            "47-90": "lazy:13_typical:13_active:13"
        };

        let activityLevel = (() => {
            switch (activity) {
                case '1':
                    return "lazy";
                case '3':
                    return "active";
                default:
                    return "typical";
            }
        });

        // Get value from calculations based on 'weight:activity'
        // E.g. weight '18' & activity 'active' would return 23
        let days = 0;
        for (let wt in calculations) {
            let wtCheckArray = GetAllNumbersOfArray(ReturnArrayFromString(wt.split('-')));
            if (wtCheckArray.includes(parseInt(weight))) {
                let ChakArray = calculations[wt].split('_');
                for (let j = 0; j < ChakArray.length; j++) {
                    if (ChakArray[j].split(':')[0] === activityLevel()) {
                        days = parseInt(ChakArray[j].split(':')[1]);
                        break;
                    }
                }
                break;
            }
        }
        return days;
    }

    function GetAllNumbersOfArray(MyArrayCaheck) {
        var First = MyArrayCaheck[0], last = MyArrayCaheck[MyArrayCaheck.length - 1], ReturnArray = [];
        for (var m = First; m <= last; m++) {
            ReturnArray.push(m);
        }
        return ReturnArray;
    }

    function ReturnArrayFromString(array) {
        var res = array;
        for (var i = 0; i < res.length; i++) {
            res[i] = parseInt(res[i], 10);
        }
        return res;
    }

    if ($('#autocomplete').length) {

        // if(google.maps.places.Autocomplete) initAutocomplete();
    }

    if ($('#replaceCardForm').length > 0) {
        $('#replaceCard').on('click', function () {
            $('#replaceCardForm').show();
        });
    }

    $('.showEditForm').on('click', function () {
        let pos = $(this).data('pos');

        $('.sub-' + pos).hide();
        $('.form-' + pos).show();
    });

    $('input[type=date].onlyFutureDate').each(function () {
        // Get today's date
        const today = new Date();

        // Add one day to today's date
        today.setDate(today.getDate() + 1);

        // Format the date as YYYY-MM-DD
        const tomorrow = today.toISOString().split('T')[0];

        // Set the min attribute to tomorrow's date
        $(this).prop('min', tomorrow);
    });

    let addresschk = $('input[name=UpdateAddress]');
    if (addresschk.length) {
        if (!addresschk.is(':checked')) {
            $('#Form_EditForm').find('.addressForm').hide();
        }
        addresschk.on('change', function () {
            if ($(this).is(':checked')) {
                $('#Form_EditForm').find('.addressForm').show();
            } else {
                $('#Form_EditForm').find('.addressForm').hide();
            }
        });
    }
});
